import {
  Box,
  Button,
  Checkbox,
  Fade,
  MenuItem,
  Paper,
  Popper,
  PopperPlacementType,
  Select,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  IconButton,
} from "@mui/material";
import DangerousRoundedIcon from '@mui/icons-material/DangerousRounded';
// import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { DetailTrans } from "../prc/TzaDetailDialog";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { SearchBackDrop } from "../../component/common/SearchBackDrop";
import CustomPagination from "../../component/common/CustomPagination";
import EvalJsonDialog from "../EvalJsonDialog";


const initailEvknData: any = {
  idx : -1,

  task: "simpleqa",
  data_sources: "",
  category: "",
  subcategory: "",
  bmk_pk: "",
  difficulty: "",
  keyword: "",
  title: "",
  text: "",
  
  qa_type: "",
  answer_type: "",
  science_fact: "",
  common_knowledge: "",
  
  activity: "",
  question_a: "",
  question_b: "",
  question: "",

  answer: "",
  answer_index: "",

  option_1: "",
  option_2: "",
  option_3: "",
  option_4: "",
  option_5: "",

  reason_1: "",
  reason_2: "",
  reason_3: "",
  reason_4: "",
  reason_5: "",

  job_user:"",
  job_date:"",
  des:"",
};

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const EvknCategory = (props: any) => {

  const [pageType, setPageType] = useState("new")

  const [openJsonDialog, setOpenJsonDialog] = useState<boolean>(false)

  const [search_doc_id, setSearch_doc_id] = useState("")

  const [evkn_detail_data, setEvkn_detail_data] = useState<any>(initailEvknData);

  const [page, setPage] = useState(1);
  const [c_page, setC_page] = useState("")
  const [order, setOrder] = useState('desc');
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const [pagination, setPagination] = useState<pageInfoType | undefined>(undefined);

  const [evknCategoryList, setEvknCategoryList] = useState([]);

  const [idx, setIdx] = useState('');
  const [job_yn, setJob_yn] = useState('모두');
  const [gub_cd, setGub_cd] = useState('모두');


  const [backdrop, setBackdrop] = useState<boolean>(false)

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  const createPrcEvknData = async () => {

    setBackdrop(true)
    if(evkn_detail_data.category == "None" || evkn_detail_data.category == ""){
      alert('주제분류 를 선택하세요.')
      return;
    }

    if(evkn_detail_data.answer == "None" || evkn_detail_data.answer == ""){
      alert('Answer - 입력하세요.')
      return;
    }

    // Task 마다 처리 해야함
    if((evkn_detail_data.question == "None" || evkn_detail_data.question == "") || (evkn_detail_data.question == "None" || evkn_detail_data.question == "")){
      alert('Question - 입력하세요.')
      return;
    }

    const formData = new FormData();

    formData.append("email", email);

    formData.append("worker", worker);

    formData.append("prc_data", JSON.stringify(evkn_detail_data));

    // console.log('json', JSON.stringify(evkn_detail_data))

    // return;

    await api.post("/prc-evkn-insert",formData)
    .then((res:any) => {alert("가공데이터 입력 완료"); setPageType("update"); setBackdrop(false);})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error); setBackdrop(false);})

  }

  function normalizeReasonPathToString(input: any): string {
    if (!input) return "[]";
    if (Array.isArray(input)) return JSON.stringify(input);
    try {
      // 이미 문자열이면 유효성 확인 후 그대로 사용 (배열 JSON인지 확인)
      const parsed = JSON.parse(input);
      return Array.isArray(parsed) ? JSON.stringify(parsed) : "[]";
    } catch {
      // 잘못된 문자열이면 빈 배열
      return "[]";
    }
  }

  // 2) colEvknData 업데이트 (불변성 유지)
  

  // 2) colEvknData 업데이트 (불변성 유지)
  const updateColEvknData = async (gub: any) => {

    if (!colEvknData) return;

    setBackdrop(true);
    
    const formData = new FormData();

    formData.append("email", email);
    formData.append("worker", worker);
    formData.append("document_id", colEvknData.document_id);

    // gub 값(1/2/3)에 따라 fix_category_detail 값 결정
    let fixCategoryDetail = "";

    if (gub === "1") {
      // 기존 카테고리
      fixCategoryDetail = colEvknData.category_detail || "";
    } else if (gub === "2") {
      // 후보-1 카테고리
      fixCategoryDetail = colEvknData.new_category_detail || "";
    } else if (gub === "3") {
      // 후보-2 카테고리 (필드명: ys_new_category_detail 사용)
      fixCategoryDetail = colEvknData.ys_new_category_detail || "";
    } else if (gub === "Y") {
      // console.log('???',colEvknData.select_category)
      if(colEvknData.select_category == undefined){
          alert("'선택 카테고리'의 값이 없습니다.")
          setBackdrop(false);
          return ;
        }
      // 후보-2 카테고리 (필드명: ys_new_category_detail 사용)
      fixCategoryDetail = colEvknData.select_category || "";
    } else if (gub === "N") {
      // 후보-2 카테고리 (필드명: ys_new_category_detail 사용)
      fixCategoryDetail = "N";
    } else if (gub === "일반상식") {
      // 후보-2 카테고리 (필드명: ys_new_category_detail 사용)
      fixCategoryDetail = "일반상식";
    } else {
      // 버튼 클릭 등 다른 경우는 기존 값 유지(필요시 여기서 다른 로직 추가)
      fixCategoryDetail = colEvknData.fix_category_detail || "";
    }

    formData.append("fix_category_detail", fixCategoryDetail);

    // alert(colEvknData.document_id + " 카테고리 검수 완료" + " 선택 카테고리 ="+ fixCategoryDetail);
    // setBackdrop(false);
    // getEvknCategoryWorkList(true);
    // return ;
    await api.post("/updateEvknCategoryData", formData)
      .then((res: any) => {
        alert(colEvknData.document_id + " 카테고리 검수 완료" + " 선택 카테고리 ="+ fixCategoryDetail);
        setBackdrop(false);

        // 목록 재조회 후 첫 번째 row 자동 선택
        getEvknCategoryWorkList(true);
      })
      .catch((error: any) => {
        alert('오류 - ' + error.response.data.error);
        setBackdrop(false);
      });

  }

  const [colEvknData, setColEvknData] = useState<any>([]);

  const [reason_path, setReason_path] = useState<any>([]);

  const reason_path_change = (idx: number, val: string) => {
    setReason_path((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  };

  const [options, setOptions] = useState<any>([]);

  const options_change = (idx: number, val: string) => {
    setOptions((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  };

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  const getEvknCategoryWorkList = async (selectFirst: boolean = false) => {
    
    let v_gub_cd = "1";

    setBackdrop(true);
    api.get('/evknCategoryList', { params: { email: email, worker: worker, page: page, order: order, job_yn: job_yn, gub_cd: v_gub_cd, idx: idx } })
      .then((res: any) => {
        
        if (res.data.datas.length > 0) {
          setEvknCategoryList(res.data.datas);

          if (selectFirst) {
            // 호출 시 명시적으로 첫 번째 row 선택
            setColEvknData(res.data.datas[0]);
          } else {
            // 기존 동작 유지
            if ((colEvknData && colEvknData.idx == -1) || (pagination && page != pagination.current_page)) {
              setColEvknData(res.data.datas[0]);
            }
          }

          setPagination(res.data.pagination);
          setTotal_cnt(res.data.pagination.total_count);
        } else {
          setEvknCategoryList(res.data.datas);
          setPagination(res.data.pagination);
          setTotal_cnt(0);
        }
        setBackdrop(false);
      })
      .catch((error: any) => { console.error('에러', error.response); setBackdrop(false); })
  }

  useEffect(() => {
    if(props.rowDetail != undefined){
      if(props.rowDetail.instruction_data == 'Y'){
        // getPrcDetail(props.rowDetail.idx)
        // getSwInstructionDetail(props.rowDetail.idx)
        setPageType("update")
      }else{
        // getPrcDetail(props.rowDetail.idx)
        setEvkn_detail_data(initailEvknData);
        setPageType("new")
      }
    }
    getEvknCategoryWorkList()
  }, [page, gub_cd, job_yn, props.rowDetail]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // 입력 중일 때(텍스트 필드/텍스트에어리어 등)에는 핫키 동작 막기
      const target = e.target as HTMLElement;
      if (target) {
        const tagName = target.tagName;
        if (tagName === "INPUT" || tagName === "TEXTAREA" || (target as any).isContentEditable) {
          return;
        }
      }

      if (e.key === "1") {
        e.preventDefault();
        updateColEvknData("1");
      } else if (e.key === "2") {
        e.preventDefault();
        updateColEvknData("2");
      } else if (e.key === "3") {
        e.preventDefault();
        updateColEvknData("3");
      } else if (e.key === "0") {
        e.preventDefault();
        updateColEvknData("N");
      } else if (e.key === "7") {
        e.preventDefault();
        updateColEvknData("일반상식");
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [colEvknData]); // 현재 선택된 row 정보에 맞게 동작하도록 colEvknData 의존

  // if(prc_data == undefined) {return <Paper sx={{width:"100%", overflow: "auto"}}><Box sx={{fontWeight:700, fontSize: "52px"}}>Loading ...</Box></Paper>}

  return (
    <Paper sx={{width:"100%", overflow: "auto"}}>
      {backdrop && ( <SearchBackDrop message={"처리중..."}/> )}
      <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>지식 - 카테고리 검수</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box display="flex">

        <Box display="flex">
          <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#acdffc"}}>
            <Box sx={{width:"1050px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
              <Box sx={{display:"flex", alignItems:"center"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{display:"flex", alignItems:"center", justifyContent:"left"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"120px"}}>document_id</Box>
                      <TextField
                        value={colEvknData.document_id}
                        variant="outlined"
                        size="small"
                        sx={{ width: "300px", mr: 1 ,backgroundColor: "#fff"}}
                      />
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"120px"}}>데이터 출처</Box>
                      <TextField
                        value={colEvknData.data_sources}
                        variant="outlined"
                        size="small"
                        sx={{ width: "300px", mr: 1 ,backgroundColor: "#fff"}}
                      />

                      {/* <Button sx={{ marginLeft: "100px"}} variant="contained" color="secondary" onClick={updateKeep}>
                        데이터 선정
                      </Button> */}
                    </Box>
                    <Box sx={{alignItems:"center", justifyContent:"center"}}>
                      {/* <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류 (CATEGORY)</Box>
                      <Select id="topic_cd" value={colEvknData.category || ""} onChange={(e) => {setColEvknData({ ...colEvknData, category: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"790px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={""}>선택하세요</MenuItem>
                        <MenuItem dense value={"101"}>한국형-역사</MenuItem>
                        <MenuItem dense value={"102"}>한국형-문화</MenuItem>
                        <MenuItem dense value={"103"}>한국형-사회</MenuItem>
                        <MenuItem dense value={"104"}>한국형-지리</MenuItem>
                        <MenuItem dense value={"105"}>한국형-언어</MenuItem>
                        <MenuItem dense value={"106"}>한국형-정치및법</MenuItem>
                        <MenuItem dense value={"201"}>글로벌-일반상식</MenuItem>
                        <MenuItem dense value={"202"}>글로벌-과학</MenuItem>
                        <MenuItem dense value={"203"}>글로벌-인문학및사회학</MenuItem>
                        <MenuItem dense value={"204"}>글로벌-공학및기술</MenuItem>
                        <MenuItem dense value={"205"}>글로벌-경제</MenuItem>
                        <MenuItem dense value={"206"}>글로벌-기타</MenuItem>
                      </Select> */}
                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                      <Box><textarea value={colEvknData.keyword} onChange={(e) => {setColEvknData({ ...colEvknData, keyword: e.target.value });}} spellCheck="false" style={{width:"1000px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>
                    </Box>
                    <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                    <Box><textarea value={colEvknData.title} onChange={(e) => {setColEvknData({ ...colEvknData, title: e.target.value });}} spellCheck="false" style={{width:"1000px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                    <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                    <Box><textarea value={colEvknData.text} onChange={(e) => {setColEvknData({ ...colEvknData, text: e.target.value });}} spellCheck="false" style={{width:"1000px",minHeight:"520px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                  </Box>
                </Box>
              </Box>
            </Box>
          </Paper>
        </Box>

        {/* category */}
        <Box display="flex">
          <Box sx={{width:"100%"}}>
            <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#e4ffdc"}}>
              <Box sx={{margin:"4px"}}>
                <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                  <Box>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>CATEGORY 검수</Box>
                  </Box>
                </Box>
              </Box>

              {(colEvknData.fix_category_detail !== "" && colEvknData.job_yn === "Y") ? 
              <Box sx={{width:"400px"}}>
                <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>**최종 카테고리**</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box><textarea readOnly={true} spellCheck="false" value={colEvknData.fix_category_detail || ""} onChange={(e) => {setColEvknData({ ...colEvknData, fix_category_detail: e.target.value });}} style={{border:"4px solid #000", width:"370px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR" }}  /></Box>
                  </Box>
                </Box>
                <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
              </Box>
              :""}

              <Box sx={{width:"400px"}}>
                <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>기존 카테고리</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box><textarea readOnly={true} spellCheck="false" value={colEvknData.category_detail || ""} onChange={(e) => {setColEvknData({ ...colEvknData, category_detail: e.target.value });}} style={{border:"4px solid #000", width:"370px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR" }}  /></Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"400px", marginTop:"8px"}}>
                <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>후보-1 카테고리</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box><textarea readOnly={true} spellCheck="false" value={colEvknData.new_category_detail || ""} onChange={(e) => {setColEvknData({ ...colEvknData, answer: e.target.value });}} style={{border:"4px solid #000", width:"370px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR" }}  /></Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"400px", marginTop:"8px"}}>
                <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>후보-2 카테고리</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box><textarea readOnly={true} spellCheck="false" value={colEvknData.ys_new_category_detail || ""} onChange={(e) => {setColEvknData({ ...colEvknData, answer: e.target.value });}} style={{border:"4px solid #000", width:"370px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR" }}  /></Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"400px", marginTop:"8px"}}>
                <Box sx={{margin:"2px 0px 0px 12px", fontWeight:700}}>선택 카테고리</Box>
                  <Select id="topic_cd" value={colEvknData.select_category || ""} onChange={(e) => {setColEvknData({ ...colEvknData, select_category: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"370px", height: "28px", border:"2px solid #498ad5", padding: "2px", borderRadius:"4px"}}>
                    <MenuItem dense value={""}>선택하세요</MenuItem>
                    <MenuItem dense value={"역사"}>한국형-역사</MenuItem>
                    <MenuItem dense value={"문화"}>한국형-문화</MenuItem>
                    <MenuItem dense value={"사회"}>한국형-사회</MenuItem>
                    <MenuItem dense value={"지리"}>한국형-지리</MenuItem>
                    <MenuItem dense value={"언어"}>한국형-언어</MenuItem>
                    <MenuItem dense value={"정치및법"}>한국형-정치및법</MenuItem>
                    <MenuItem dense value={"일반상식"}>글로벌-일반상식</MenuItem>
                    <MenuItem dense value={"과학"}>글로벌-과학</MenuItem>
                    <MenuItem dense value={"인문학및사회학"}>글로벌-인문학및사회학</MenuItem>
                    <MenuItem dense value={"공학및기술"}>글로벌-공학및기술</MenuItem>
                    <MenuItem dense value={"경제"}>글로벌-경제</MenuItem>
                    <MenuItem dense value={"기타"}>글로벌-기타</MenuItem>
                  </Select>
              </Box>

              <Box sx={{width:"100%", marginTop: "16px"}}>
                <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#fff9c1"}}>
                  <Box display="flex">

                    <Box sx={{width:"100%", marginTop: "8px"}}>
                      <Box display="flex" justifyContent="center">
                        <Button variant="contained" color="primary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                          onClick={() => {
                            updateColEvknData('Y');
                          }}
                        >
                          선택 저장
                        </Button>
                      </Box>
                    </Box>
                    
                    <Box sx={{width:"100%", marginTop: "8px"}}>
                      <Box display="flex" justifyContent="center">
                        <Button variant="contained" color="secondary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                          onClick={() => {
                            updateColEvknData('N');
                          }}
                        >
                          제외
                        </Button>
                      </Box>
                    </Box>
                        
                  </Box>
                  
                </Paper>
              </Box>
              
            </Paper>
          </Box>
        </Box>
        {/* simpleQA */}

        {/* 작업 리스트 */}
        <Box>
        {/* Task 단위 화면 */}
        <Box display="flex" justifyContent="center" >
          <Box sx={{padding:"4px 8px 8px 8px", width:"368px"}}>
            <Box display="flex">
              <Box><img style={{width:"24px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/ko_flag.jpg'} /></Box>
              <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>작업목록</Box>
              <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>검수구분</Box> 
              <Select id="job_yn" value={job_yn || "모두"} onChange={(e) => {setJob_yn(e.target.value );}} sx={{backgroundColor: "#fff",color:"green",width:"180px", height: "28px", marginLeft: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                <MenuItem dense value={"모두"}>모두</MenuItem>
                <MenuItem dense value={"Y"}>선택 저장</MenuItem>
                <MenuItem dense value={"N"}>제외</MenuItem>
              </Select>
            </Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
              <Table size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>검수</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>카테고리</Box></TableCell>
                    {/* <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>CONCEPT</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>USE_CHECK</Box></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                {(evknCategoryList != undefined && evknCategoryList.length > 0) ? evknCategoryList.map((row:any, index:number) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' } , backgroundColor:(colEvknData != undefined && row.idx === colEvknData.idx ? "#dbdbef": "#fff")}}
                    onClick={()=> {setColEvknData(row);}}
                  >
                    <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                    {/* <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"38px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.isp1_yn === "N" ? "2px solid red" : (row.isp1_yn === "0" ? "2px solid #bbb" : (row.isp1_yn === "Y" ? "2px solid #27cc2f" : "#000"))), color:"#000" }}>
                        {(row.isp1_yn === "Y" ? "적합" : (row.isp1_yn === "N" ? "부적합" : (row.isp1_yn === "0" ? "미작업":"-")))}
                      </Box>
                    </TableCell> */}
                    {/* <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"38px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.instruction_data === "Y" ? "2px solid #27cc2f" : "2px solid #bbb"), color:"#000" }}>
                        {(row.instruction_data === "Y" ? "작성" : "미작성")}
                      </Box>
                    </TableCell> */}
                    <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"38px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.job_yn === "Y" ? "2px solid #27cc2f" : (row.job_yn === "P" ? "2px solid #7427cc" : "#000")), color:"#000" }}>
                        {(row.job_yn === "Y" ? "완료" : (row.job_yn === "N" ? "X" : "미작업"))}
                      </Box>
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"48px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px", color:"#000" }}>
                        {/* {row.fix_category_detail} */}
                        {
                          row.fix_category_detail === "101" ? "한국형-역사" :
                          row.fix_category_detail === "102" ? "한국형-문화" :
                          row.fix_category_detail === "103" ? "한국형-사회" :
                          row.fix_category_detail === "104" ? "한국형-지리" :
                          row.fix_category_detail === "105" ? "한국형-언어" :
                          row.fix_category_detail === "106" ? "한국형-정치및법" :
                          row.fix_category_detail === "201" ? "글로벌-일반상식" :
                          row.fix_category_detail === "202" ? "글로벌-과학" :
                          row.fix_category_detail === "203" ? "글로벌-인문학및사회학" :
                          row.fix_category_detail === "204" ? "글로벌-공학및기술" :
                          row.fix_category_detail === "205" ? "글로벌-경제" :
                          row.fix_category_detail === "206" ? "글로벌-기타" :
                          ""
                        }
                      </Box>
                    </TableCell>
                    {/* <TableCell align="left">{row.concept_en}</TableCell> */}
                    {/* <TableCell align="left">
                      <Box sx={{width:"58px",fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                          border: (row.use_check === "F" ? "2px solid red" : (row.use_check === "T" ? "2px solid #498ad5" : (row.use_check === "C" ? "2px solid #27cc2f" : "#bbb"))), color:"#000" }}>
                        {(row.use_check === "T" ? "사용가능" : (row.use_check === "F" ? "사용불가" : (row.use_check === "C" ? "내용수정":"미분류")))}
                      </Box>
                    </TableCell> */}
                  </TableRow>
                  )):<TableRow><TableCell colSpan={3} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{marginTop:"12px"}}>
              {pagination !== undefined ? (
                  <>
                  <CustomPagination pagination={pagination} goPage={goPage} />
                  <Box display="flex">
                  <TextField size="small" id="worker" value={c_page} onChange={(e)=>setC_page(e.target.value)} 
                    sx={{width:"60px",height: "23px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} 
                    InputProps={{
                      style: {width: "60px", height:"23px", fontSize:"12px"},
                      inputProps: { 
                        spellCheck: "false" // spellcheck를 false로 설정
                      },
                    }}
                    />
                    <Button variant="contained" sx={{marginLeft:"8px",minWidth: "58px", height:"30px", fontSize:"12px"}} onClick={()=>setPage(Number(c_page))}>
                      이동
                    </Button>
                  </Box>
                  </>
              ) : ""}
            </Box>
          </Box>
          
          
        </Box>
      </Box>
            
        {/* : ""} */}
        
      </Box>

    </Paper>
  );
  
  
};

export default EvknCategory;
